var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top"},[_c('icon-back',{staticClass:"back",attrs:{"color":"rgba(33, 34, 39, 1)"},on:{"back":_vm.back}}),_c('strong',[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }